module.exports = __webpack_public_path__ + "assets/images/warning.a548a5326fe04605b67da20ace4b30c4.svg";